package api.repository.properties

import api.data.DataProperty
import api.data.request.DataAddProperty
import api.data.request.DataUpdateProperty
import api.data.request.DataUpdatedPropertyStatus
import api.service.properties.ServiceProperties
import org.w3c.files.File

class ImplRepositoryProperties(val serviceProperties: ServiceProperties): RepositoryProperties{
    override suspend fun addProperty(dataAddProperty: DataAddProperty): Boolean {
        return serviceProperties.addProperty(dataAddProperty)
    }

    override suspend fun getProperties(): ArrayList<DataProperty>? {
        return serviceProperties.getProperties()
    }

    override suspend fun updateProperty(dataUpdateProperty: DataUpdateProperty): Boolean {
        return serviceProperties.updateProperty(dataUpdateProperty)
    }

    override suspend fun removeProperty(dataProperty: DataProperty): Boolean {
        return serviceProperties.removeProperty(dataProperty)
    }

    override suspend fun approveProperty(dataProperty: DataProperty): Boolean {
        return serviceProperties.approveProperty(dataProperty)
    }

    override suspend fun rejectProperty(dataProperty: DataProperty): Boolean {
        return serviceProperties.rejectProperty(dataProperty)
    }

    override suspend fun updatePropertyStatus(dataUpdateStatus: DataUpdatedPropertyStatus): Boolean {
        return serviceProperties.updatePropertyStatus(dataUpdateStatus)
    }
}
